// extracted by mini-css-extract-plugin
export default {"Sliders":"Sliders_Sliders__Xgu+n","spinner":"Sliders_spinner__QKEC2"};